import { render, staticRenderFns } from "./AddMaterialCard.vue?vue&type=template&id=b9555068&scoped=true&"
import script from "./AddMaterialCard.vue?vue&type=script&lang=js&"
export * from "./AddMaterialCard.vue?vue&type=script&lang=js&"
import style0 from "./AddMaterialCard.vue?vue&type=style&index=0&id=b9555068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9555068",
  null
  
)

export default component.exports